import { render } from "./ClientTallerOrdenVer.vue?vue&type=template&id=75b0f90e&scoped=true"
import script from "./ClientTallerOrdenVer.vue?vue&type=script&lang=js"
export * from "./ClientTallerOrdenVer.vue?vue&type=script&lang=js"

import "./ClientTallerOrdenVer.vue?vue&type=style&index=0&id=75b0f90e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b0f90e"]])

export default __exports__